<template>
  <div class="profile-page">
    <div class="user-info" v-if="user">
      <img class="avatar" :src="user.avatar" alt="User Avatar" />
      <div class="details">
        <h2>{{ user.nickname }}</h2>
        <!-- <p>{{ user.sn }}</p> -->
      </div>
    </div>

    <div class="user-info" v-if="!user">
      <img class="avatar" src="../assets/user.png" @click="logonUser" alt="User Avatar" />
      <div class="details">
        <span @click="logonUser">点击登录</span>
      </div>
    </div>


    <div class="order-status">
      <h3>我的订单</h3>
      <ul>
        <li v-for="status in orderStatuses" :key="status.id" @click="orderView(status)">
          <img :src="status.icon" />
          <div>{{status.name}}</div>
        </li>
      </ul>
    </div>

    <div class="menu-options">
      <h3>我的服务</h3>
      <ul>
        <li v-for="menu in menus" :key="menu.id" @click="afterView(menu)">
          <img :src="menu.icon" />
          <div>{{menu.name}}</div>
        </li>
      </ul>
    </div>


    <div class="arrowed-label">精选好物</div>

    <div class="product-list">
      <div class="product-item" v-for="product in products" :key="product.id">
        <img :src="product.picture_src" :alt="product.product_name" class="product-image">
        <h3 class="product-name">{{ product.product_name }}</h3>
        <p class="product-price">￥{{ product.price }}</p>
        <button class="add-to-cart-button" @click="addToCart(product)">立即购买</button>
      </div>
    </div>
    <div class="nav-container">
      <div class="nav-item" v-for="item in menuItems" :key="item.label" @click="footerChange(item)">
        <img :src="item.icon"></img>
        <div class="label">{{ item.label }}</div>
      </div>
    </div>
  </div>

</template>

<script>
  import {
    getHomeGoods
  } from "../utils/api"
  export default {
    data() {
      return {
        user: null,
        menuItems: [{
            icon: require('../assets/homes.png'),
            label: '首页'
          },
          {
            icon: require('../assets/fenlei.png'),
            label: '分类'
          },
          {
            icon: require('../assets/slmy.png'),
            label: '我的'
          }
        ],
        orderStatuses: [{
            id: 1,
            name: '全部订单',
            icon: require('../assets/allorder.png')
          },
          {
            id: 2,
            name: '待付款',
            icon: require('../assets/dfk.png')
          },
          {
            id: 3,
            name: '待发货',
            icon: require('../assets/dfh.png')
          },
          {
            id: 4,
            name: '待收货',
            icon: require('../assets/dsh.png')
          },
          // {
          //   id: 5,
          //   name: '已完成',
          //   icon: require('../assets/over.png')
          // },
          // {
          //   id: 5,
          //   name: '待评价',
          //   icon: require('../assets/dpj.png')
          // },
        ],
        menus: [
          // {
          //   id: 1,
          //   name: '优惠劵',
          //   icon: require('../assets/myyhj.png')
          // },
          // {
          //   id: 2,
          //   name: '服务进度',
          //   icon: require('../assets/fwjd.png')
          // },
          // {
          //   id: 3,
          //   name: '投诉建议',
          //   icon: require('../assets/tujy.png')
          // },

          // {
          //   id: 4,
          //   name: '设置',
          //   icon: require('../assets/wdsz.png')
          // },
          {
            id: 5,
            name: '退款/售后',
            path:'afterSales',
            icon: require('../assets/tksh.png')
          },
          // {
          //   id: 6,
          //   name: '联系客服',
          //   icon: require('../assets/lxkf.png')
          // },
          {
            id: 7,
            name: '用户协议',
            path:'agreement',
            icon: require('../assets/yhxy.png')
          },
          {
            id: 8,
            name: '隐私协议',
            path:'privacy',
            icon: require('../assets/ysxy.png')
          },
          {
            id: 9,
            name: '退款政策',
            path:'logistics',
            icon: require('../assets/tuikuan.png')
          },
          {
            id: 9,
            name: '物流政策',
            path:'logisticsPolicy',
            icon: require('../assets/wlzc.png')
          },
        ],
        products: [],
        page: 1,
      };
    },
    created() {

      let user = this.$store.getters.getUser
      if(user){
        this.user = user;
      }else{
        this.user = null;
      }
      this.getGoodsList(); //获取商品列表
    },
    methods: {
      footerChange(item){
        switch (item.label){
          case "分类":
            this.$router.push({
              name: 'itemize',
            })
            break;
          case "首页":
            this.$router.push({
              name: 'shopIndex',
            })
            break;
        }
        console.log(item,"sss")
      },
      addToCart(product) {

        this.$router.push({
          name: 'shopping',
          query: {
            code_id: product.landing_page_info_code,
            clickid:'2024'
          }
        })
        // 这里可以添加更多的逻辑，比如更新购物车显示、保存购物车状态等
      },
      //跳转
      orderView(order){
        this.$router.push({
          name:'myorder',
          query:{
            id:order.id
          }
        })
      },
      afterView(menu){
        this.$router.push({
          name:menu.path,
          query:{
            id:menu.id
          }
        })
      },
      //
      logonUser(){
        this.$router.replace({
          path: '/login'
        })
      },
      getGoodsList() {
        getHomeGoods({
          page: this.page
        }).then(res => {
          this.products =res.data;

        })
      },
    },
  };
</script>

<style scoped>
  .profile-page {
    height: 100vh;
    background-color: #F8F9FB;
  }

  .user-info {
    display: flex;
    align-items: center;
    padding: 20px;
  }

  .avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-right: 20px;
    border: 1px solid #989898;
  }

  .details h2 {
    margin: 0;
    font-size: 24px;
  }

  .details p {
    margin: 0;
    color: #666;
  }

  .order-status {
    padding: 20px 10px;
    background-color: #fff;
  }

  .order-status ul {
    list-style-type: none;
    padding: 0;
    display: flex;
  }

  .order-status li {
    flex: 1;
    text-align: center;
  }

  .order-status li img {
    width: 25px;
    height: 25px;
  }

  .order-status li:first-child {
    border-right: 1px solid #ccc;
  }

  .menu-options {
    padding: 20px 10px;
    margin-top: 10px;
    background-color: #fff;
  }

  .menu-options ul {
    padding: 0;
    list-style-type: none;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
  }

  .menu-options li {
    flex: 1;
    text-align: center;
  }

  .menu-options li img {
    width: 25px;
    height: 25px;
  }

  .arrowed-label {
    text-align: center;
    position: relative;
    color: #989898;
    margin-top: 20px;
  }

  .arrowed-label::after {
    content: "";
    border-bottom: 1px solid #989898;
    position: absolute;
    width: 140px;
    right: 6%;
    top: 10px;
  }

  .arrowed-label::before {
    content: "";
    /* border: 1px solid; */
    border-bottom: 1px solid #989898;
    position: absolute;
    width: 140px;
    left: 6%;
    top: 10px;
  }
  /* 商品列表 */
  .product-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-bottom: 60px;
  }

  .product-item {
    background-color: #fff;
    margin: 10px;
    padding: 10px;
    height: auto;
    border-radius: 5px;
  }

  .product-image {
    width: 100%;
    height: 180px;
  }

  .product-name {
    margin: 10px 0;
    font-weight: bold;
    color: #000;
  }

  .product-price {
    color: red;
    font-weight: bold;
  }

  .add-to-cart-button {
    background-color: red;
    color: white;
    border: none;
    width: 100%;
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 5px;
  }

  .add-to-cart-button:hover {
    background-color: darkblue;
  }

  .nav-container {
    display: flex;
    justify-content: space-around;
    background-color: #f8f9fa;
    padding: 10px 0;
    border-top: 1px solid #ccc;
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .nav-item {
    text-align: center;
    flex-grow: 1;

  }

  .nav-item img {
    width: 25px;
    height: 25px;
  }

  .icon {
    display: block;
    font-size: 24px;
    color: #333;
  }

  .label {
    font-size: 12px;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/components/my.vue